import React from "react";
import ScheduleAwardsSummaryCard from "./components/ScheduleAwardsSummaryIndex.jsx";

const ScheduleAwardsSummary = () => <ScheduleAwardsSummaryCard />;

export default ScheduleAwardsSummary;
